import{useState as r}from"react";import{useRouter as o}from"next/navigation";var t=function(){var t=r(!1),e=t[0],n=t[1],a=o();return{loading:e,routerPush:function(r){n(!0),a.push(r)},routerReplace:function(r,o){void 0===o&&(o=!1),o||n(!0),a.replace(r)},router:a}};export{t as default};
//# sourceMappingURL=index.js.map
